export default __webpack_public_path__ + "static/herobanner-bonus-latitude-rewards-4c3bfcabd918208795eb9b7c98c81e68.webp";